import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import cd from 'debug';
import { compose } from 'redux';
import core, { View, App } from '@gin-betting/core';

import matchListModule from 'modules/match-list';
import { SidebarLoader } from 'components';
import { ACTIVE_MARKET_STATUSES } from 'app-constants';

const {
    hocs: { makePure },
} = core;
const {
    getTopMarketComponentsBySport,
    actions: { getCustomMarketMatches },
    selectors: { selectTopMarketsByMatchId, selectMatchFetchStatus },
} = matchListModule;

const debug = cd('match-list:components:TopMarkets');

interface MappedProps {
    topMarkets: ReturnType<typeof selectTopMarketsByMatchId>;
    matchFetchStatus: ReturnType<typeof selectMatchFetchStatus>;
}

interface MappedActions {
    getMatches: typeof getCustomMarketMatches;
}

interface OwnProps {
    matchId: string;
    hasMatchHeader: boolean;
    sportId: string;
    count: number;
}

type Props = OwnProps & MappedProps & MappedActions;

export class Markets extends React.Component<Props> {
    getMatches = () => {
        const { matchId, topMarkets } = this.props;

        const marketTypes = topMarkets.map(market => market.typeId);

        this.props.getMatches({
            sportEventsIds: [matchId],
            marketTypes,
            marketStatuses: ACTIVE_MARKET_STATUSES,
        });
    };

    render() {
        debug('render', this.props);
        const {
            topMarkets,
            hasMatchHeader,
            sportId,
            count,
            matchFetchStatus,
            matchId,
        } = this.props;

        const topMarketComponentsBySport = getTopMarketComponentsBySport(
            sportId,
            { count }
        );

        const commonProps = {
            hasMatchHeader,
            getCustomMarketMatches: this.getMatches,
            matchId,
            hasVS: true,
            isDefaultName: true,
        };

        const renderMarkets: JSX.Element[] = [];

        topMarketComponentsBySport.reduce((acc, item, idx) => {
            const { nextMarkets, ReactNode } = item(acc, commonProps, idx);
            renderMarkets.push(ReactNode);

            return nextMarkets;
        }, topMarkets);

        return (
            <Fragment>
                {matchFetchStatus === App.FetchStatus.LOADING && (
                    <SidebarLoader />
                )}
                {renderMarkets}
            </Fragment>
        );
    }
}

const makeMapStateToProps = createStructuredSelector<MappedProps>({
    topMarkets: selectTopMarketsByMatchId,
    matchFetchStatus: selectMatchFetchStatus,
});

const mapDispatchToProps = {
    getMatches: getCustomMarketMatches,
};

export default compose<React.ComponentClass<OwnProps>>(
    connect<MappedProps, MappedActions, OwnProps>(
        makeMapStateToProps,
        mapDispatchToProps
    ),
    makePure({
        maxDepth: 3,
        excludedKeys: ['odds', 'specifiers'],
    })
)(Markets);

export type Market = View.Market;
